import styled from 'styled-components';

export const StyledCreateItem = styled.p`
  cursor: pointer;
  margin: 0;
  padding: 8px 12px;
  border-top: 1px solid #f0f0f0;
  color: black;
`;
